import { Button, Stack, Typography } from "@mui/material";
import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import { api } from "../../../api/operationsApi";
import { useExecutionState } from "../../../hooks/useExecutionState";
import ExecutionStatusAlert from "../../common/ExecutionStatusAlert";

const clearSystemCaches = withErrorHandling(api.systemMaintenance.clearCaches);

const SystemMaintenanceContent = () => {
  const { executionState, setExecutionState } = useExecutionState();

  const handleExecute = async () => {
    setExecutionState({ status: "in-progress" });

    const [resp, error] = await clearSystemCaches();
    if (error) {
      setExecutionState({ status: "error", error });
      return;
    }

    setExecutionState({ status: "success", details: [convertISODateTime(resp.timestamp)] });
  };

  return (
    <Stack spacing={3} sx={{ alignItems: "flex-start", width: "24rem" }}>
      <Typography variant="subtitle1">Clear System Caches</Typography>
      <Button variant="contained" loading={executionState.status === "in-progress"} onClick={handleExecute}>
        Clear
      </Button>
      <ExecutionStatusAlert executionState={executionState} setExecutionState={setExecutionState} />
    </Stack>
  );
};

export default SystemMaintenanceContent;
